import axios from "axios";
import { workerActions } from "../../../store/slices/workers";
import { warehouseActions } from "../../../store/slices/warehouse";

export const getSharedFilesId = "sharedFiles";
export const sharedFilesData = "sharedFiles";

export const getSharedFiles = (data) => {
  const { server, cloner_key, user: login, controller } = data;
  const id = getSharedFilesId;

  return async (dispatch) => {
    dispatch(workerActions.start(id));
    try {
      const url = server + "api/shares";
      const response = await axios.get(url, {
        signal: controller.signal,
        headers: { cloner_key },
        params: { login },
      });
      let list = [];
      let simpleList = [];
      for (const item of response.data) {
        list.push(item);
        simpleList.push(item.id);
      }
      dispatch(warehouseActions.load({ id: sharedFilesData, data: list }));
      dispatch(workerActions.finish({ id }));
    } catch (e) {
      if (e.code === "ERR_CANCELED") {
        dispatch(workerActions.clear(id));
        return;
      }
      console.error(e);
      dispatch(workerActions.finish({ id, error: e.message }));
    }
  };
};
